<template>
  <div class="report">
    <div class="container">
      <div class="row">
        <div class="col-12 justify-content-center d-flex mb-4" v-if="isAdmin">
          <button 
            @click="changeDownloadStatus(!download_files)"
            class="btn"
            :class="{'btn-primary': download_files == true, 'btn-secondary': download_files == false}">
            <span v-if="download_files == true">正在下载文件</span>
            <span v-else-if="download_files == false">已停止下载文件</span>
            <span v-else></span>
          </button>  
        </div>
      </div>
      <div class="row">
        <form class="col-12 d-flex justify-content-center">
          <div class="input-group col-4">
            <div class="input-group-prepend">
              <span class="input-group-text">开始</span>
            </div>
            <input title="开始时间" min="2017-12-11" max="2100-01-01" class="form-control" type="date" v-model="begin" v-on:change="updateDate()">
          </div>

          <div class="input-group col-4">
            <div class="input-group-prepend">
              <span class="input-group-text">结束</span>
            </div>
            <input title="结束时间" min="2017-12-11" max="2100-01-01" class="form-control" type="date" v-model="end" v-on:change="updateDate()">
          </div>
          <button-group :p-button-group="buttonGroup" size="md"></button-group> 
          <button class="btn btn-primary mx-2" v-on:click.prevent="exportData">按创建时间导出</button>
          <button class="btn btn-primary mx-2" v-on:click.prevent="exportDeliveryData">发货时间统计</button>
        </form>

        <form id='export-spreadsheet-form' enctype='multipart/form-data' method='post' action='/api/orders/spreadsheet'>
            <input type='hidden' name='name'>
            <input type='hidden' name='begin'>
            <input type='hidden' name='end'>
            <input type='hidden' name='company_code'>
          </form>
      </div>
      
      <div class="row chart d-flex justify-content-center">
        <div id="chart3" style="height:300px;" class="col-6"></div>
        <div id="chart4" style="height:300px;" class="col-6"></div>
      </div>      

      <div class="row chart d-flex justify-content-center">
        <div id="chart1" style="height:300px;" class="col-12"></div>
      </div>

      <div class="row chart d-flex justify-content-center">
        <div id="chart2" style="height:300px;" class="col-12"></div>
      </div>
    </div>
  </div>
</template>


<script type="text/javascript">
import dayjs from 'dayjs'
import ButtonGroup from '@/components/_partial/ButtonGroup'
import OrderMixin from '@/mixins/order'
import RoleMixin from '@/mixins/role'
import {toQueryString} from '@/utils/tools'
import {buildOptionForOrders, buildOptionForShippedOrders, buildOptionForCompany} from '@/utils/report'

function loadData () {
  let query = {
    begin: this.begin,
    end: this.end
  }
  if (this.$route.query.company_code) {
    query.company_code = this.$route.query.company_code
  }

  this.$http.get('/api/reports?' + toQueryString(query)).then(response => {
    this.data = response.data.data
    drawCharts(this.data)
  })

  this.$http.get('/api/buckets/config_download_files').then(response => {
    this.download_files = response.data.data["value"]
  })
}

function drawCharts (data) {
  const EC = window.echarts
  let chart1 = EC.init(document.getElementById('chart1'))
  let chart2 = EC.init(document.getElementById('chart2'))
  let chart3 = EC.init(document.getElementById('chart3'))
  let chart4 = EC.init(document.getElementById('chart4'))

  chart1.setOption(buildOptionForOrders(data.orders))
  chart2.setOption(buildOptionForShippedOrders(data.orders))
  chart3.setOption(buildOptionForCompany('未发货订单-产品', data.unshipped.product))
  chart4.setOption(buildOptionForCompany('未发货订单-状态', data.unshipped.status))
}

function exportData () {
  let form = document.getElementById('export-spreadsheet-form')
  form.querySelector('input[name="name"]').setAttribute('value', 'export-order-spreadsheet')

  form.querySelector('input[name="begin"]').setAttribute('value', this.begin)
  form.querySelector('input[name="end"]').setAttribute('value', this.end)
  form.querySelector('input[name="company_code"]').setAttribute('value', this.$route.query.company_code || '')

  form.submit()
}

function exportDeliveryData () {
  let form = document.getElementById('export-spreadsheet-form')
  form.querySelector('input[name="name"]').setAttribute('value', 'export-delivery-spreadsheet')

  form.querySelector('input[name="begin"]').setAttribute('value', this.begin)
  form.querySelector('input[name="end"]').setAttribute('value', this.end)
  form.querySelector('input[name="company_code"]').setAttribute('value', this.$route.query.company_code || '')

  form.submit()
}

function updateDate () {
  let newQuery = {
    begin: this.begin,
    end: this.end
  }

  if (this.$route.query.company_code) {
    newQuery.company_code = this.$route.query.company_code
  }

  if ('?' + toQueryString(newQuery) !== location.search) {
    this.$router.push({ query: newQuery })
  }
}

function changeDownloadStatus (toggle) {
  this.$http.put('/api/buckets/config_download_files', {
    "value": toggle
  }).then(response => {
    this.download_files = toggle
  })
}

export default {
  name: 'report',
  mixins: [OrderMixin, RoleMixin],
  components: {
    ButtonGroup
  },
  data () {
    let begin = this.$route.query.begin
    if (!begin) {
      let now = new Date()
      begin = dayjs(now.setDate(now.getDate() - 7)).format('YYYY-MM-DD')
    }

    let end = this.$route.query.end
    if (!end) {
      end = dayjs().format('YYYY-MM-DD')
    }

    return {
      begin: begin,
      end: end,
      download_files: null
    }
  },
  mounted () {
    if (!window.echarts) {
      var script = document.createElement('script')
      script.src = 'https://cdn.bootcss.com/echarts/4.0.4/echarts.min.js'
      script.onload = () => {
        this.loadData()
      }
      document.head.appendChild(script)
    } else {
      this.loadData()
    }
  },
  computed: {
    buttonGroup () { return this.computeCompanyButtonGroup() }
  },
  methods: {
    loadData,
    drawCharts,
    exportData,
    exportDeliveryData,
    updateDate,
    changeDownloadStatus
  },
  watch: {
    '$route.query': function () {
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .chart{
    padding: 40px 0
  }
</style>